// Bundle all utilities into a single module
var ODataDataProvider = require('./provider/ODataDataProvider.js');
var FileSaver = require('./filesaver/FileSaver.js');

module.exports = {
	oData: {
		fetch: ODataDataProvider.requestData,
		getConverter: ODataDataProvider.getConverter
	},
	saveFile: FileSaver.saveFile
};


//////////////////
// WEBPACK FOOTER
// ./client/src/export-utils.js
// module id = 36
// module chunks = 1